import { Box } from '@material-ui/core'
import React from 'react'
import { BuildingEnergyModelFragment } from '../../../generated/graphql'
import { EnergySystemList } from '../energy-system/EnergySystemList'
import { ScheduleList } from '../schedule/ScheduleList'

type Props = {
  buildingEnergyModel: BuildingEnergyModelFragment
}

export function BemCalculationTab({
  buildingEnergyModel,
}: Props): React.ReactElement {
  return (
    <Box>
      <EnergySystemList buildingEnergyModel={buildingEnergyModel} />

      <ScheduleList buildingEnergyModel={buildingEnergyModel} />
    </Box>
  )
}
